import React, { useState, useEffect } from "react";
import "./Modal.scss";
import closeIcon from "../../../assets/images/close.svg";
import loadingModalIcon from "../../../assets/images/loading_modal.svg";
import verifiedIcon from "../../../assets/images/verified-sign.svg";
import { IModalProps } from "../../../interfaces/Index";

const Modal: React.FC<IModalProps> = (props: IModalProps) => {
  const [CloseModal, setCloseModal] = useState(props.showModal);

  const closeModal = () => {
    if (props.closeModalHandler) props.closeModalHandler?.();
    setCloseModal(false);
  };

  useEffect(() => {
    setCloseModal(props.showModal);
  }, [props.showModal]);

  return (
    <>
      {CloseModal && (
        <section className={`modal-container ${props.containerClass}`}>
          <div className="close-modal-outside" onClick={closeModal}></div>

          <section className={`modal-body ${props.modalBodyClass}`}>
            <section className="modal-heading">
              {props.modalHeading}
              {props.showCloseButton && (
                <span className="close-modal" onClick={closeModal}>
                  <img src={closeIcon} alt="close" />
                </span>
              )}
            </section>
            {props.children && (
              <section className={props.childrenWrapper}>
                {props.children}
              </section>
            )}
            {props.modalLoading && (
              <section className="uplaod-complete">
                <img src={loadingModalIcon} alt="close" />
              </section>
            )}
            {props.isSuccess && (
              <section className="uplaod-complete">
                <img src={verifiedIcon} alt="close" />
              </section>
            )}

            {props.showProgressString ? (
              <section className="upload-complete-sign">
                {props.isSuccess ? "Upload Complete" : "Upload in progress"}
              </section>
            ) : null}

            {props.modalLoading && (
              <>
                <section className="rows-uploaded">
                  Please have a quick break <br />
                  while we add these <br />
                  products to our system.
                </section>
              </>
            )}

            {props.isSuccess && props.totalRowUpload ? (
              <section className="rows-uploaded">
                {props.totalRowUpload}
              </section>
            ) : (
              ""
            )}
            {props.isSuccess && props.itemsUploaded ? (
              <section className="items-uploaded">
                {props.itemsUploaded}
              </section>
            ) : (
              ""
            )}

            {props.failedRecords ? (
              <section className="failed-records">
                {props.failedRecords}
              </section>
            ) : (
              ""
            )}
          </section>
        </section>
      )}
    </>
  );
};

Modal.defaultProps = {
  modalHeading: "Modal Heading",
  totalRowUpload: "",
  itemsUploaded: "",
  failedRecords: "",
  uploadComplete: true,
  isSuccess: false,
  modalLoading: false,
  showProgressString: true,
  showCloseButton: true,
  closeModalOnBackgroundClick: true,
};

export default Modal;
